/**
 * Cuándo se considera que un documento ya está puesto.
 *
 * No siempre es "tiene archivo". Los formatos que se diligencian en línea no
 * suben nada: la declaración de residencia y la carta de conformación quedan
 * con su fecha de firma, y el escrito y video con el texto o el enlace.
 *
 * Mirar solo url_participante dejaba esos documentos como faltantes aunque
 * estuvieran completos, y por eso un paso podía decir "Incompleto" con todo
 * hecho.
 */

const tieneTexto = (valor: any): boolean => String(valor ?? '').trim() !== '';

/** Un documento administrativo: archivo subido, o formato firmado en línea. */
export const aportado = (documento: any): boolean =>
  tieneTexto(documento?.url_participante) || tieneTexto(documento?.fecha_firma);

/** Un documento técnico: archivo subido, o el escrito y video diligenciado. */
export const aportadoTecnico = (documento: any): boolean =>
  tieneTexto(documento?.url_participante) ||
  tieneTexto(documento?.escrito) ||
  tieneTexto(documento?.url_video);

/**
 * ¿Está resuelto ese grupo de documentos?
 *
 * Una lista vacía cuenta como resuelta: hay líneas que no piden documentos
 * técnicos, y exigir uno de una lista que no tiene ninguno dejaba el paso en
 * "Incompleto" para siempre, sin nada que la persona pudiera hacer.
 */
export const grupoResuelto = (
  documentos: any,
  esta: (documento: any) => boolean = aportado
): boolean => {
  const lista = Array.isArray(documentos) ? documentos : [];
  return lista.length === 0 || lista.some(esta);
};
